import React from 'react';
import { useDispatch } from "react-redux";
import { useNavigate,useLocation  } from 'react-router-dom';
import './Breadcrumb.css';

const Breadcrumb = React.memo(
    ({
        userName,
        departmentName,
        folderName,
        deptId,
        folderId,
        hidePath = false,
    }) => {
        const navigate = useNavigate();
        const dispatch = useDispatch();
        const location = useLocation();

        const isExactFolderPage = /^\/department\/[^/]+\/folder\/[^/]+$/.test(location.pathname);

        const handleDeptClick = () => {
            if (deptId && folderName) {
                dispatch({ type: "CLEAR_DATA_FOLDER" });
                navigate(`/department/${deptId}`, { state: { forceReload: Date.now() } });
            }
        };

        const handleFolderClick = () => {
            if (!isExactFolderPage && deptId && folderId) {
                dispatch({ type: "CLEAR_DATA_FOLDER" });
                navigate(`/department/${deptId}/folder/${folderId}`, { state: { forceReload: Date.now() } });
            }
        };

        return (
            <div className='lay-breadcrumb'>
                <div className='item'>
                    {!hidePath && (
                        <ul>

                            {/* DEPARTMENT */}
                            {departmentName && (
                                <>
                                    <li
                                        className={folderName ? "bc-link" : ""}
                                        onClick={folderName ? handleDeptClick : undefined}
                                    >
                                        {departmentName}
                                    </li>

                                    {folderName && <span className="bc-separator">/</span>}
                                </>
                            )}

                            {/* FOLDER */}
                            {folderName && (
                                <li
                                    className={!isExactFolderPage ? "bc-link" : ""}
                                    onClick={!isExactFolderPage ? handleFolderClick : undefined}
                                >
                                    {folderName}
                                </li>
                            )}

                        </ul>
                    )}
                </div>

                <div className='option' id='option'>
                    <img src="/img/common/user.svg" alt="" style={{width: '24px', height: '24px'}}/>
                    <span id='login_user_name'>{userName}</span>
                </div>
            </div>
        );
    }
);

export default Breadcrumb;
